(() => {
  function init() {
    const form = document.getElementById('adw-product-form');
    if (!form || form.dataset.bound) return;
    form.dataset.bound = 'true';
    const variant = form.querySelector('#variant');
    const qty = form.querySelector('#quantity');
    const teeth = form.querySelector('#teeth');
    const error = form.querySelector('#form-error');
    const submit = form.querySelector('#case-submit');
    const total = form.querySelector('#case-total');
    function update() {
      const n = Number(qty.value);
      const option = variant.options[variant.selectedIndex];
      const valid = Number.isInteger(n) && n >= 1 && n <= 3;
      total.textContent = valid ? new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(Number(option.dataset.price)*n/100) : 'Enter 1–3 units';
      if (submit) submit.disabled = option.dataset.available !== 'true';
      teeth.setCustomValidity('');
      error.textContent = '';
    }
    variant.addEventListener('change',update); qty.addEventListener('input',update); teeth.addEventListener('input',()=>{teeth.setCustomValidity('');error.textContent='';});
    form.addEventListener('submit', e => {
      const tokens = teeth.value.split(',').map(v=>v.trim());
      const numbers = tokens.map(Number);
      if(tokens.length !== Number(qty.value) || tokens.some(v=>!/^\d{1,2}$/.test(v)) || numbers.some(v=>v<1||v>32) || new Set(numbers).size !== numbers.length) {
        e.preventDefault();
        const message = 'Enter one unique US tooth number (1–32) per unit. For 3 units, use 3 comma-separated numbers.';
        error.textContent = message; teeth.setCustomValidity(message); teeth.reportValidity(); teeth.focus();
      }
    }); update();
  }
  init(); document.addEventListener('shopify:section:load',init);
})();
